// extracted by mini-css-extract-plugin
export default {"wrap":"Avatar_wrap__dXSRd","text":"Avatar_text__gfBZt","agency":"Avatar_agency__1v5-1","avatarImage":"Avatar_avatarImage__uXlMs"};